import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import virtual1 from "../../assets/images/blogs/virtual1.png";
import "../BlogOne.css";
import "./RecentBlogs.css";
import "./RecentBlogsMobile.css";
import newblogimg from "../../assets/images/blogs/newblogimg2.png";
import { Button } from "@mui/material";
import financeacc1 from "../../assets/images/blogs/finance-acc-2.png";
import global1 from '../../assets/images/blogs/Global-Expansion.png';
import financeplan12025 from "../../assets/images/blogs/financeplan1-2025.png";
import financeplan22025 from "../../assets/images/blogs/financeplane-2-2025.png";
import bgblog from "../../assets/images/blogs/bf-blog-3.png";
import bgblog1 from "../../assets/images/blogs/bf-blog-1.png";

const RecentBlogs = () => {
  const [hovered, setHovered] = useState(null);

  return (
    <div
      style={{
        display: window.innerWidth < 768 ? "none" : "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginBottom: "50px",
        marginTop: "20px",
        width: "100%",
        textAlign: "left",
      }}
    >
      <div className="pb-2 mb-5">
        <h3
          className="text-center"
          style={{
            color: "#072f5f",
            display: "inline",
            fontWeight: "bold",
            fontSize: "30px",
          }}
        >
          INSIGHTS FROM BOSTON FINANCIAL
        </h3>
      </div>

      <div style={styles.row}>
        {/* card1 */}
        <Link
          to="/financial-accounting-trend"
          style={styles.card}
          onMouseEnter={() => setHovered(1)}
          onMouseLeave={() => setHovered(null)}
        >
          <div
            style={{
              ...styles.cardImage,
              backgroundImage: `url(${financeacc1})`,
            }}
          >
            <div
              className={`cardOverlay ${hovered === 1 ? "overlayVisible" : ""}`}
              style={{
                ...styles.cardOverlay1,
                ...(hovered === 1 ? styles.overlayVisible : {}),
              }}
            ></div>
            <div style={styles.cardDateContainer}>
              <div style={styles.cardDate}>Jun 6, 2025</div>
              <div style={styles.cardDateLine}></div>
            </div>
            <div style={styles.cardTitle}>
              Financial Accounting Trends in 2025: Cloud Tech, Outsourcing{" "}
              <br /> & Smart Forecasting
            </div>
          </div>
        </Link>
        {/* card1 */}

        {/* card2 */}
        <Link
          to="/global-expansion"
          style={styles.card}
          onMouseEnter={() => setHovered(2)}
          onMouseLeave={() => setHovered(null)}
        >
          <div
            style={{
              ...styles.cardImageSmall,
              backgroundImage: `url(${global1})`,
            }}
          >
            <div
              className={`cardOverlay ${hovered === 2 ? "overlayVisible" : ""}`}
              style={{
                ...styles.cardOverlay2,
                ...(hovered === 2 ? styles.overlayVisible : {}),
              }}
            ></div>
            <div style={styles.cardDateContainer}>
              <div style={styles.cardDate}>Jun 5, 2025</div>
              <div style={styles.cardDateLine}></div>
            </div>
            <div style={styles.cardTitle2}>
              Global Expansion? Here's Why Your Business Needs an International
              CPA Outsourcing Partner.
            </div>
          </div>
        </Link>
        {/* card2 */}
      </div>

      <div style={styles.row}>
        {/* card3 */}
        <Link
          to="/beyond-bookkeeping"
          style={styles.card}
          onMouseEnter={() => setHovered(3)}
          onMouseLeave={() => setHovered(null)}
        >
          <div
            style={{
              ...styles.cardImageNoBorder,
              backgroundImage: `url(${bgblog1})`,
            }}
          >
            <div
              className={`cardOverlay ${hovered === 3 ? "overlayVisible" : ""}`}
              style={{
                ...styles.cardOverlay3,
                ...(hovered === 3 ? styles.overlayVisible : {}),
              }}
            ></div>
            <div style={styles.cardDateContainer}>
              <div style={styles.cardDate}>May 10, 2025</div>
              <div style={styles.cardDateLine}></div>
            </div>
            <div style={styles.cardTitle}>
              Beyond Bookkeeping: The Emergence of Strategic Financial <br />{" "}
              Consulting for International Businesses
            </div>
          </div>
        </Link>
        {/* card3 */}

        {/* card4 */}
        <Link
          to="/post-tax-season-strategy"
          style={styles.card}
          onMouseEnter={() => setHovered(4)}
          onMouseLeave={() => setHovered(null)}
        >
          <div
            style={{
              ...styles.cardImageNoBorder4,
              backgroundImage: `url(${bgblog})`,
            }}
          >
            <div
              className={`cardOverlay ${hovered === 4 ? "overlayVisible" : ""}`}
              style={{
                ...styles.cardOverlay4,
                ...(hovered === 4 ? styles.overlayVisible : {}),
              }}
            ></div>
            <div style={styles.cardDateContainer}>
              <div style={styles.cardDate}>May 9, 2025</div>
              <div style={styles.cardDateLine}></div>
            </div>
            <div style={styles.cardTitle}>
              Post-Tax Season Strategy: CFO and Finance Team Areas of Focus for
              the Future
            </div>
          </div>
        </Link>
        {/* card4 */}

        {/* card5 */}
        <Link
          to="/navigating-new-regulations"
          style={styles.card}
          onMouseEnter={() => setHovered(5)}
          onMouseLeave={() => setHovered(null)}
        >
          <div
            style={{
              ...styles.cardImageNoBorder5,
              backgroundImage: `url(${financeplan12025})`,
            }}
          >
            <div
              className={`cardOverlay ${hovered === 5 ? "overlayVisible" : ""}`}
              style={{
                ...styles.cardOverlay5,
                ...(hovered === 5 ? styles.overlayVisible : {}),
              }}
            ></div>
            <div style={styles.cardDateContainerOpposite}>
              <div style={styles.cardDateOpposite}>Apr 10, 2025</div>
              <div style={styles.cardDateLineOpposite}></div>
            </div>
            <div style={styles.cardTitle}>
              Navigating New Regulations: What Every Financial <br /> Advisor
              Needs to Know Now{" "}
            </div>
          </div>
        </Link>
        {/* card5 */}
      </div>

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Link to="/blogs">
          <Button
            className="buttonUnique read-more-button"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#072f5f",
              padding: "8px 24px",
              fontSize: "16px",
              minWidth: "120px",
            }}
          >
            Read More
          </Button>
        </Link>
      </div>
      {/* <div style={{ display: window.innerWidth < 768 ? "none" : "" }}>
      <SubBlogs />
      </div> */}
    </div>
  );
};

const styles = {
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "@media (max-width: 768px)": {
      display: "none",
      items: "center",
    },
  },
  row: {
    display: "flex",
    gap: "20px",
    marginBottom: "20px",
  },
  card: {
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
  },
  cardImage: {
    width: "780px",
    height: "410px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderBottomRightRadius: "39%",
    clipPath: "polygon(0 0, 100% 0, 100% 85%, 85% 100%, 0 100%)",
    position: "relative",
    transition: "transform 0.3s ease",
    marginRight: "0px",
  },
  cardImage6: {
    width: "1200px",
    height: "400px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    // borderBottomRightRadius: '39%',
    // clipPath: "polygon(0 0, 100% 0, 100% 85%, 85% 100%, 0 100%)",
    position: "relative",
    transition: "transform 0.3s ease",
    marginRight: "0px",
  },
  cardImage14: {
    width: "1200px",
    height: "400px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    // borderBottomRightRadius: '39%',
    // clipPath: "polygon(0 0, 100% 0, 100% 85%, 85% 100%, 0 100%)",
    position: "relative",
    transition: "transform 0.3s ease",
    marginRight: "0px",
  },
  cardImageSmall: {
    width: "400px",
    height: "410px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderBottomLeftRadius: "40%",
    position: "relative",
    transition: "transform 0.3s ease",
    marginLeft: "0px",
  },
  cardImageNoBorder: {
    width: "400px",
    height: "410px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
  },
  cardImageNoBorder10: {
    width: "590px",
    height: "410px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
  },
  cardImageNoBorder9: {
    width: "590px",
    height: "410px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
  },
  cardImageNoBorder4: {
    width: "380px",
    height: "410px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    borderTopRightRadius: "45%",
    transition: "transform 0.3s ease",
  },

  cardImageNoBorder7: {
    width: "590px",
    height: "410px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    borderTopRightRadius: "45%",
    transition: "transform 0.3s ease",
  },
  cardImageNoBorder5: {
    width: "380px",
    height: "410px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    borderTopLeftRadius: "45%",
    transition: "transform 0.3s ease",
  },
  cardImageNoBorder8: {
    width: "590px",
    height: "410px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    borderTopLeftRadius: "45%",
    transition: "transform 0.3s ease",
  },
  cardOverlay1: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderBottomRightRadius: "39%",
    backgroundColor: "transparent",
    transition: "background-color 0.3s ease",
  },
  cardOverlay6: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    // borderBottomRightRadius: '39%',
    backgroundColor: "transparent",
    transition: "background-color 0.3s ease",
  },
  cardOverlay14: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    // borderBottomRightRadius: '39%',
    backgroundColor: "transparent",
    transition: "background-color 0.3s ease",
  },
  cardOverlay2: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderBottomLeftRadius: "40%",
    backgroundColor: "transparent",
    transition: "background-color 0.3s ease",
  },
  cardOverlay3: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    // borderBottomRightRadius: '38%',
    backgroundColor: "transparent",
    transition: "background-color 0.3s ease",
  },
  cardOverlay10: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    // borderBottomRightRadius: '38%',
    backgroundColor: "transparent",
    transition: "background-color 0.3s ease",
  },
  cardOverlay9: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    // borderBottomRightRadius: '38%',
    backgroundColor: "transparent",
    transition: "background-color 0.3s ease",
  },
  cardOverlay4: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderTopRightRadius: "45%",
    backgroundColor: "transparent",
    transition: "background-color 0.3s ease",
  },
  cardOverlay7: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderTopRightRadius: "45%",
    backgroundColor: "transparent",
    transition: "background-color 0.3s ease",
  },
  cardOverlay5: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderTopLeftRadius: "45%",
    backgroundColor: "transparent",
    transition: "background-color 0.3s ease",
  },
  cardOverlay8: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderTopLeftRadius: "45%",
    backgroundColor: "transparent",
    transition: "background-color 0.3s ease",
  },
  overlayVisible: {
    backgroundColor: "rgba(0, 112, 255, 0.61)",
  },
  cardDateContainer: {
    position: "absolute",
    top: "10px",
    left: "10px",
    display: "flex",
    alignItems: "center",
  },
  cardDate: {
    color: "white",
    background: "rgba(0, 0, 0, 0.5)",
    padding: "5px 10px",
    borderRadius: "5px",
    Underline: "none",
  },
  cardDateLine: {
    flexGrow: 1,
    height: "2px",
    background: "white",
    marginLeft: "10px",
  },
  cardTitle: {
    position: "absolute",
    bottom: "10px",
    left: "10px",
    right: "10px",
    color: "white",
    fontSize: "22px",
    fontWeight: "600",
    textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
  },
  cardTitle2: {
    position: "absolute",
    bottom: "40px",
    left: "50px",
    right: "10px",
    color: "white",
    fontSize: "22px",
    fontWeight: "600",
    textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
  },
  cardDateContainerOpposite: {
    position: "absolute",
    top: "10px",
    right: "10px",
    display: "flex",
    alignItems: "center",
  },
  cardDateOpposite: {
    color: "white",
    background: "rgba(0, 0, 0, 0.5)",
    padding: "5px 10px",
    borderRadius: "5px",
  },
  cardDateLineOpposite: {
    flexGrow: 1,
    height: "2px",
    background: "white",
    marginRight: "10px",
  },
};

export default RecentBlogs;
